<template>
  <div id="rightMid">
    <div class="bg-color-black">
      <myTitle :icon="'chart-line'">设备维修</myTitle>
      <div class="d-flex jc-center body-box">
        <dv-scroll-board class="dv-scr-board" :config="config" />
      </div>
    </div>
  </div>
</template>
    
<script>
import myTitle from '@/components/common/title'
export default {
  data() {
    return {
      config: {
        header: ['编号', '事件', '状态'],
        data: [
          ['123123', '管道漏水(2.20)', "待维护"],
          ['567223', '变频器更换(2.21)', "已完成"],
          ['235623', '消防水泵更换(2.30)', "维修中"],
          ['342366', '摄像头更换(2.25)', "待维护"],
          ['234567', '断路器维护(2.23)', "已完成"],
        ],
        rowNum: 5, //表格行数
        headerHeight: 35,
        headerBGC: '#0f1325', //表头
        oddRowBGC: '#0f1325', //奇数行
        evenRowBGC: '#171c33', //偶数行
        index: true,
        columnWidth: [100],
        align: ['center']
      }
    }
  },
  components: {
    myTitle
  },
}
</script>
    
<style lang="scss" scoped>
$box-height: 300px;
$box-width: 100%;

#rightMid {
  padding: 20px 16px;
  height: $box-height;
  width: $box-width;
  border-radius: 5px;

  .bg-color-black {
    height: $box-height - 35px;
    border-radius: 10px;
  }

  .text {
    color: #c3cbde;
  }

.body-box {
  border-radius: 10px;
  overflow: hidden;

  .dv-scr-board {
    width: 100%;
    height: 240px;
  }
}
}
</style>
    